import {Text, View} from '@react-pdf/renderer';
import styles from '../styles';

export default function CoordinatesTableSection({
  xData,
  yData,
  zData,
}: {
  xData: string[];
  yData: string[];
  zData: string[];
}) {
  return (
    <View wrap={false} style={styles.section}>
      <View style={styles.sectionCard}>
        <Text
          style={{
            alignSelf: 'flex-end',
            fontSize: 12,
            fontWeight: 500,
            marginBottom: 10,
          }}
        >
          مختصات نقاط مزرعه
        </Text>
        <View style={styles.CoordinatesTable}>
          <Row label="نقطه" data={['1', '2', '3', '4', '5', '6']} />
          <Row label="X" data={xData} topBorder bottomBorder />
          <Row label="Y" data={yData} bottomBorder />
          <Row label="Z" data={zData} />
        </View>
      </View>
    </View>
  );
}

interface IRowProps {
  topBorder?: boolean;
  bottomBorder?: boolean;
  data: string[];
  label: string;
}

function Row({topBorder, bottomBorder, data, label}: IRowProps) {
  return (
    <View
      style={[
        styles.CoordinatesRow,
        {borderTop: `${topBorder ? '1px solid #E0E3E5' : 'none'}`},
        {borderBottom: `${bottomBorder ? '1px solid #E0E3E5' : 'none'}`},
      ]}
    >
      <View style={[styles.CoordinatesCell, {width: 60, flex: 'none'}]}>
        <Text style={{alignSelf: 'center'}}>{label}</Text>
      </View>
      {Array.from({length: 5}, (_, i) => data[i] ?? '-').map(item => (
        <View style={[styles.CoordinatesCell, {fontSize: 13}]}>
          <Text>{item}</Text>
        </View>
      ))}
    </View>
  );
}
